// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export const Footer = styled<any, Theme>('footer')`
  border-top: 1px solid ${props => props.theme.cart.borderColor};
  padding-top: 1.5rem;
`;

export default null;
